import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import BuyingGuidePage from "@/pages/buyingGuide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/buying-guide",
    element: <BuyingGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;